import { MATCH, MISMATCH, NOT_AVAILABLE, checkStorageQuota, getAspectRatio, getParsedUserAgent } from "../util";
import { DeviceValidationChecks, ValidationChecks } from "../typings/AppStateTypes";
import { checkStatus } from "./ServiceTypes";
import TimeService from "./timeService";
import { fetchService } from "../services/fetchService";
import { ValidationResponse, ValidationResponseCheck } from "@npd-ng/adp-types";
import {NCSHealthResponse} from "../typings";;
import {serializeError} from 'serialize-error';
import {NdtClient,NdtInput} from '@npd-ng/network-diagnostic-tool'
const logPrefix = "[ADP Student App][DeviceValdationService]";

export const getErrorCheckPayload = (
  checkName:ValidationChecks,validationChecks: DeviceValidationChecks,
  errorMessage?:unknown,value?:any,passOnFailure?:boolean) =>{
  return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
    const errorCheck: ValidationResponse & checkStatus = {
      name: validationChecks[checkName]?.name || checkName,
      threshold: validationChecks[checkName]?.threshold?.toString() || NOT_AVAILABLE,
      time: TimeService.current(),
      type: validationChecks[checkName]?.type || ValidationResponseCheck.SOFT_CHECK,
      message: `Error : ${JSON.stringify(serializeError(errorMessage))}`,
      value: value ?? NOT_AVAILABLE,
      isCheckPassed: passOnFailure ?? true,
      actionOnFailure: "ApplicationError"
    }
    resolve(errorCheck);
  })
 }
export function DeviceValidationService(deviceValidationCnfg: DeviceValidationChecks) {
  const DeviceValidation = deviceValidationCnfg;
 
  const performCPUCheck = async (value: any) => {
    const cpuValue = value === NOT_AVAILABLE || Number.isNaN(value.percent) ? NOT_AVAILABLE :  parseFloat(value?.percent)
     return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const CPUCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkCPU.name || "checkCPU",
        threshold: DeviceValidation?.checkCPU.threshold.toLocaleString() || "70",
        time: TimeService.current(),
        type: DeviceValidation?.checkCPU.type || ValidationResponseCheck.SOFT_CHECK,
        message: cpuValue === NOT_AVAILABLE ? "Skipped" :  DeviceValidation?.checkCPU.threshold < cpuValue ? "Failure" : "Success",
        value: value,
        isCheckPassed: cpuValue === NOT_AVAILABLE ? true : DeviceValidation?.checkCPU.threshold > cpuValue,
        actionOnFailure: "FailedHardwareCheck"
      }
      resolve(CPUCheck);
    })
  }
  const performDeviceIdCheck =  async (value: any) => {
     return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const CPUCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkDeviceId.name || "checkDeviceId",
        threshold: DeviceValidation?.checkDeviceId.threshold.toLocaleString() || "NotAvailable",
        time: TimeService.current(),
        type: DeviceValidation?.checkDeviceId.type || ValidationResponseCheck.SOFT_CHECK,
        message: value?.deviceIdType === NOT_AVAILABLE ? "Skipped" : "Success",
        value: value,
        isCheckPassed: true,
        actionOnFailure: "FailedHardwareCheck"
      }
      resolve(CPUCheck);
    })
  }
  const performMemoryCheck = async (value: any, failureMsg: string) => {
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const memoryCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkMemory.name || "checkMemory",
        threshold: DeviceValidation?.checkMemory.threshold || 3000000000,
        time: TimeService.current(),
        type: DeviceValidation?.checkMemory.type || ValidationResponseCheck.HARD_CHECK,
        message:value === NOT_AVAILABLE ? "Skipped" : value?.total < DeviceValidation?.checkMemory.threshold ? "Failure" : "Success",
        value: value,
        isCheckPassed: value === NOT_AVAILABLE ? true : value?.total > DeviceValidation?.checkMemory.threshold,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      resolve(memoryCheck);
    })
  }
  const performStorageCheck = async (value: any, failureMsg: string) => {
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const freeStorage  = value === NOT_AVAILABLE || Number.isNaN(parseInt(value?.FreeSpace)) ? NOT_AVAILABLE : parseInt(value?.FreeSpace)
     console.log(freeStorage,DeviceValidation?.checkStorage.threshold,value?.FreeSpace )
      const storageCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkStorage.name || "checkStorage",
        threshold: DeviceValidation?.checkStorage.threshold || 2000000000,
        time: TimeService.current(),
        type: DeviceValidation?.checkStorage.type || ValidationResponseCheck.HARD_CHECK,
        message: freeStorage === NOT_AVAILABLE ? "Skipped" : freeStorage > DeviceValidation?.checkStorage.threshold ?  "Success" : "Failure",
        value: value,
        isCheckPassed: freeStorage === NOT_AVAILABLE ? true : freeStorage > DeviceValidation?.checkStorage.threshold,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      resolve(storageCheck);
    })
  }
  const performProccessorCheck = async (value: any, failureMsg: string) => {
    let ghzValue = Number.isNaN(value.MaxClockSpeed) || value === NOT_AVAILABLE  ? NOT_AVAILABLE : value.MaxClockSpeed
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const proccessorCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkProccessor.name || "checkProccessor",
        threshold: DeviceValidation?.checkProccessor.threshold || 1,
        time: TimeService.current(),
        type: DeviceValidation?.checkProccessor.type || ValidationResponseCheck.HARD_CHECK,
        message: ghzValue === NOT_AVAILABLE ? "Skipped" : ghzValue >= DeviceValidation?.checkProccessor.threshold ? "Success" : "Failure",
        //@ts-ignore
        value: value,
        isCheckPassed: ghzValue === NOT_AVAILABLE ? true : ghzValue >= DeviceValidation?.checkProccessor.threshold,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      resolve(proccessorCheck);
    })
  }
  const performBrightnessCheck = async (value: string) => {
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const brightnessCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkBrightness.name || "checkBrightness",
        threshold: DeviceValidation?.checkBrightness.threshold.toLocaleString() || "NotApplicable",
        time: TimeService.current(),
        type: DeviceValidation?.checkBrightness.type || ValidationResponseCheck.HARD_CHECK,
        message: "Success",
        value: value,
        isCheckPassed: true,//there are no cases in which this check fails as it is only for information purposes
        actionOnFailure: "FailedHardwareCheck",
      }
      resolve(brightnessCheck);
    })
  }
  const performSciptPermissions = async (value: string) => {
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const checkScriptPermissions: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkScriptPermissions.name || "checkScriptPermissions",
        threshold: DeviceValidation?.checkScriptPermissions.threshold.toLocaleString() || "NotApplicable",
        time: TimeService.current(),
        type: DeviceValidation?.checkScriptPermissions.type || ValidationResponseCheck.SOFT_CHECK,
        message: value.includes("Error") ? "Warning" :"Success",
        value: value,
        isCheckPassed: !value.includes("Error"),
        actionOnFailure: "FailedHardwareCheck",
      }
      resolve(checkScriptPermissions);
    })
  }
  const performHardwareCheck = async (value: string) => {
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const hardwareCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkHardware.name || "checkHardware",
        threshold: DeviceValidation?.checkHardware.threshold.toLocaleString() || "NotApplicable",
        time: TimeService.current(),
        type: DeviceValidation?.checkHardware.type || ValidationResponseCheck.HARD_CHECK,
        message: "Success",
        value: value,
        isCheckPassed: true,//there are no cases in which this check fails as it is only for information purposes
        actionOnFailure: "FailedHardwareCheck"
      }
      resolve(hardwareCheck);
    })
  }

  const performScreenResolutionCheck = (failureMsg: string, dprFailureMessage: string) => {
    console.log(logPrefix, "performScreenResolutionCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const resolutionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkScreenResolution?.name || "checkScreenResolution",
        threshold: DeviceValidation?.checkScreenResolution?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkScreenResolution?.type || ValidationResponseCheck.HARD_CHECK,
        message: "",
        value: "",
        isCheckPassed: false,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      
      const thresholdList = resolutionCheck?.threshold?.split(",");
      if (thresholdList.length > 1) {
        let height = window?.screen?.height;
        let width = window?.screen?.width;
        const responseValue = { 
          displayResolution: `${width},${height}`, 
          scale: window.devicePixelRatio, 
          layoutViewport: `${window.innerWidth},${window.innerHeight}`,
          layoutViewportWithDPR: `${window.innerWidth * window.devicePixelRatio},${window.innerHeight * window.devicePixelRatio}`,
          aspectRatio: getAspectRatio()
        };
     
        if (width >= Number.parseInt(thresholdList[0]) && height >= Number.parseInt(thresholdList[1])) {
          resolutionCheck.message = "Success"
          resolutionCheck.isCheckPassed = true;
          resolutionCheck.value = responseValue as unknown as string
        }
        else {
          height = thresholdList[2] && window.devicePixelRatio ?
          Math.ceil(window?.innerHeight * window.devicePixelRatio) : window?.innerHeight;
          width = thresholdList[2] && window.devicePixelRatio ?
          Math.ceil(window?.innerWidth * window.devicePixelRatio) : window?.innerWidth;
          resolutionCheck.message = "Screen resolution failed due to invalid DPR:"
          resolutionCheck.isCheckPassed = false;
          const responseValue = { displayResolution: `${width},${height}`, scale: window.devicePixelRatio, layoutViewport: `${window.innerWidth},${window.innerHeight}`, aspectRatio: getAspectRatio() };
         if (width >= Number.parseInt(thresholdList[0]) && height >= Number.parseInt(thresholdList[1])) {
           resolutionCheck.value = responseValue as unknown as string
           resolutionCheck.messageOnFailure = dprFailureMessage
          }
          else {
            resolutionCheck.message = "Screen resolution failed due to invalid minimum screen resolution"
            const responseValue = { displayResolution: `${width},${height}`, scale: window.devicePixelRatio, layoutViewport: `${window.innerWidth},${window.innerHeight}`, aspectRatio: getAspectRatio() };
            resolutionCheck.value = responseValue as unknown as string
          }
        }
      }
      resolve(resolutionCheck)
    })
  }

  const performScreenCheck = () => {
    console.log(logPrefix, "performScreenCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const screen = {
        availHeight: window.screen?.availHeight,
        availWidth: window.screen?.availWidth,// @ts-ignore
        availLeft: window.screen?.availLeft,// @ts-ignore
        availTop: window.screen?.availTop,
        colorDepth: window.screen?.colorDepth,
        height: window.screen?.height,// @ts-ignore
        isExtended: window.screen?.isExtended,
        orientation: { angle: window.screen?.orientation?.angle, type: window.screen?.orientation.type },
        pixelDepth: window.screen?.pixelDepth,
        width: window.screen?.width,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio
      }
      console.log(screen);
      const resolutionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkScreen?.name || "checkScreen",
        threshold: DeviceValidation?.checkScreen?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkScreen?.type || ValidationResponseCheck.SOFT_CHECK,
        message: "Success",// @ts-ignore
        value: screen,
        isCheckPassed: true,
        actionOnFailure: "DeviceValidationFailure",
      }
      resolve(resolutionCheck)
    })
  }
  const performDeviceCheck = (systemInfo: any) => {
    console.log(logPrefix, "performDeviceCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const deviceCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkDevice?.name || "checkDevice",
        threshold: DeviceValidation?.checkDevice?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkDevice?.type || ValidationResponseCheck.SOFT_CHECK,
        message: systemInfo === NOT_AVAILABLE ? "Skipped" : "Success",
        value: systemInfo,
        isCheckPassed: true,
        actionOnFailure: "DeviceValidationFailure",
      }
      resolve(deviceCheck)
    })
  }
  const performDuplicateScreenCheck = (failureMsg: string) => {
    console.log(logPrefix, "performDuplicateScreenCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const DuplicateScreenCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkDuplicateScreen?.name || "checkDuplicateScreen",
        threshold: DeviceValidation?.checkDuplicateScreen?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkDuplicateScreen?.type || ValidationResponseCheck.HARD_CHECK,
        message: "",
        value: "",
        isCheckPassed: false,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      const duplicateScreens = (window.screen as any).isExtended;//The any conversion is because the typing is wrong and doesn't beleve that the .isExtended method exists.
      DuplicateScreenCheck.value = duplicateScreens;
      if (DeviceValidation?.checkDuplicateScreen?.threshold === duplicateScreens) {
        DuplicateScreenCheck.message = "Success"
        DuplicateScreenCheck.isCheckPassed = true;
      }
      else {
        DuplicateScreenCheck.message = "Failed"
        DuplicateScreenCheck.isCheckPassed = false;
      }
      resolve(DuplicateScreenCheck)
    })
  }
  const performChromeExtensionCheck = (chromeExtensionVersion: string | undefined, failureMsg: string) => {
    console.log(logPrefix, "performChromeExtensionCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const ChromeExtension: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkChromeExtension?.name || "checkChromeExtension",
        threshold: DeviceValidation?.checkChromeExtension?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkChromeExtension?.type || ValidationResponseCheck.HARD_CHECK,
        message: "Failed",
        value: chromeExtensionVersion ?? NOT_AVAILABLE,
        isCheckPassed: false,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      if (chromeExtensionVersion!==NOT_AVAILABLE) {
        ChromeExtension.message = "Success"
        ChromeExtension.isCheckPassed = true;
      }
      resolve(ChromeExtension)
    })
  }
  const performTouchDeviceCheck = (failureMsg: string) => {
    console.log(logPrefix, "performTouchDeviceCheck");
    return new Promise<ValidationResponse & checkStatus>((resolve) => {
      const TouchDeviceCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkTouchDevice?.name || "checkTouchDevice",
        threshold: DeviceValidation?.checkTouchDevice?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkTouchDevice?.type || ValidationResponseCheck.SOFT_CHECK,
        message: `device has maxTouchPoints ${navigator.maxTouchPoints}`,
        value: navigator.maxTouchPoints > 0 ? "touch supported" : "touch not supported",
        isCheckPassed: navigator.maxTouchPoints > 0,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
      resolve(TouchDeviceCheck)
    })
  }
  //[{"os":"Windows","version":10},{"os":"CrOS","checkOs":true,"version":120}]
  type OSVersion = {os: string, version:string}
  const performOSVersionCheck = (failureMsg: string) => {
    console.log(logPrefix, "performOSVersionCheck");
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
      const OSVersionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkOSVersion?.name || "checkOSVersion",
        threshold: DeviceValidation?.checkOSVersion?.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkOSVersion?.type || ValidationResponseCheck.HARD_CHECK,
        message: "Skipped",
        value: NOT_AVAILABLE,
        isCheckPassed: false,
        actionOnFailure: "DeviceValidationFailure",
        messageOnFailure: failureMsg
      }
     let ua:any = getParsedUserAgent();
     if ((navigator as any).userAgentData) {
      const chromiumVersion = await (navigator as any).userAgentData.getHighEntropyValues(["fullVersionList"])
      console.log(" the value of the browser versions are: ",chromiumVersion.fullVersionList, )
      ua = {...ua,browserVersion:chromiumVersion.fullVersionList.filter((version:any) => version.brand.includes("Chromium"))[0]?.version}
     }
      console.log({ua});
      const threshold: OSVersion[] = DeviceValidation?.checkOSVersion?.threshold
      const thresholdPltfrm =  threshold.find((item)=>ua.os?.name?.includes(item.os));
      let major =ua.os.version?.split(".")[0];
      //console.log(major,parseInt(major ?? "0") >= parseInt(thresholdPltfrm?.version ?? "0"))
      if(thresholdPltfrm){
        //check version
        if(ua.os.name === "Chrome OS"){
          major = ua.browser.version?.split(".")[0];
        }
        if(parseInt(major ?? "0") >= parseInt(thresholdPltfrm.version)){
         OSVersionCheck.message = "Device meets minimum OS requirements";
         OSVersionCheck.value = ua as unknown as string;
         OSVersionCheck.isCheckPassed = true;
        }
        else {
          OSVersionCheck.message = "Device does not meet minimum OS version";
          OSVersionCheck.value = ua as unknown as string;
          OSVersionCheck.isCheckPassed = false; 
        }
      }
      else {
        OSVersionCheck.message = "Unsupported OS";
        OSVersionCheck.value = ua as unknown as string;
        OSVersionCheck.isCheckPassed = false;
      }
      resolve(OSVersionCheck)
    })
  }

  const performBatteryCheck = async () => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
      //@ts-ignore
      const batteryState = await navigator.getBattery();
      const batteryCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkBattery.name || "checkBattery",
        threshold: DeviceValidation?.checkBattery.threshold.toLocaleString() || "0.5",
        time: TimeService.current(),
        type: DeviceValidation?.checkBattery.type || ValidationResponseCheck.HARD_CHECK,
        message: (batteryState?.level || 0) * 100 < DeviceValidation?.checkBattery.threshold ? "Warning" : "Success",
        value: JSON.stringify({ batteryLevel: batteryState?.level, isCharging: batteryState?.charging }),
        isCheckPassed: true,
        actionOnFailure: "SystemError"
      }
      resolve(batteryCheck);
    })
  }
  const performCheckCloudServerHealth = async (healthURL: string) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const CloudServerHealthCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkCloudServerHealth.name || "checkCloudServerHealth",
        threshold: DeviceValidation?.checkCloudServerHealth.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkCloudServerHealth.type || ValidationResponseCheck.HARD_CHECK,
        message: "",
        value: "",
        isCheckPassed: false,
        actionOnFailure: "NoServerConnectionDetected"
      }
      try {
        const response = await fetchService(healthURL);
        if(response){
          CloudServerHealthCheck.message = "Success"
          CloudServerHealthCheck.value = await response.json() as unknown as string;
          CloudServerHealthCheck.isCheckPassed = true
        }
        resolve(CloudServerHealthCheck);
      }
      catch(e){
        CloudServerHealthCheck.message = "Failed"
        CloudServerHealthCheck.value = e as unknown as string;
        CloudServerHealthCheck.isCheckPassed = false
        resolve(CloudServerHealthCheck);
      }
    })
  }
  const performCheckAppName = async () => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const AppNameCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkAppName.name || "checkAppName",
        threshold: DeviceValidation?.checkAppName.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkAppName.type || ValidationResponseCheck.SOFT_CHECK,
        message: "Skipped",
        value: "NotAvailable",
        isCheckPassed: false,
        actionOnFailure: "SystemError"
      }
      try {
        const response = await fetchService("./manifest.json");
        if(response){
          AppNameCheck.message = "Success"
          AppNameCheck.value = (await response.json()).name;
          AppNameCheck.isCheckPassed = true
        }
        resolve(AppNameCheck);
      }
      catch(e){
        AppNameCheck.message = "Failed"
        AppNameCheck.value = e as unknown as string;
        AppNameCheck.isCheckPassed = false
        resolve(AppNameCheck);
      }
    })
  }
  const performCheckConnection = async () => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const ConnectionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkConnection.name || "checkConnection",
        threshold: DeviceValidation?.checkConnection.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkConnection.type || ValidationResponseCheck.HARD_CHECK,
        message: navigator.onLine ? "Connected" : "Offline",
        value: navigator.onLine ? "Connected" : "Offline",
        isCheckPassed: navigator.onLine ? true : false,
        actionOnFailure: "NoInternetConnectionDetected"
      }
      resolve(ConnectionCheck);
    })
  }
  const performCheckSystemClock = async (healthURL:string) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const systemClockCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkSystemClock.name || "checkSystemClock",
        threshold: DeviceValidation?.checkSystemClock.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkSystemClock.type || ValidationResponseCheck.HARD_CHECK,
        message: NOT_AVAILABLE,
        value: NOT_AVAILABLE,
        isCheckPassed: false,
        actionOnFailure: "FailedSystemTimeCheck"
      }
      const dateFromResponse = await TimeService.validateCurrentTime(healthURL,DeviceValidation?.checkSystemClock.threshold)
    if(dateFromResponse){
       console.log(logPrefix,'server time', dateFromResponse.serverTime, "local time", dateFromResponse.localTime);
       systemClockCheck.message = dateFromResponse.passed ? "Success" : "Failed";
       systemClockCheck.threshold = dateFromResponse.serverTime;
       systemClockCheck.value = dateFromResponse.localTime;
       systemClockCheck.isCheckPassed = dateFromResponse.passed;
         }
    else {
      console.warn(`checkSystemClock unable to get date from cloud services: (${healthURL})`);
      systemClockCheck.message = `Skipped": checkSystemClock unable to get date from cloud services: (${healthURL}. Date property is missing)`;
      systemClockCheck.value = TimeService.current();
      systemClockCheck.isCheckPassed = true;
    }
      resolve(systemClockCheck);
    })
  }
  const performCheckVersions = async (remoteVersion:string, localVersion?:string,componentVersions?: any) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const VersionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkVersions.name || "checkVersions",
        threshold: remoteVersion,
        time: TimeService.current(),
        type: DeviceValidation?.checkVersions.type || ValidationResponseCheck.HARD_CHECK,
        message: "",
        value: "",
        isCheckPassed: false,
        actionOnFailure: "FailedVersionCheck"
      }
          const value = {
            releaseVersion: remoteVersion,
            localReleaseVersion: localVersion,
            ...componentVersions
          }
          VersionCheck.message = remoteVersion===localVersion ? MATCH : MISMATCH
          VersionCheck.value = value as unknown as string
          VersionCheck.isCheckPassed = remoteVersion===localVersion;
          resolve(VersionCheck);
    })
  }
  const performCheckBrowserStorage = async () => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
     const storageDetails = await checkStorageQuota();
     const VersionCheck: ValidationResponse & checkStatus = {
        name: DeviceValidation?.checkBrowserStorage.name || "checkBrowserStorage",
        threshold: DeviceValidation?.checkBrowserStorage.threshold,
        time: TimeService.current(),
        type: DeviceValidation?.checkBrowserStorage?.type || ValidationResponseCheck.SOFT_CHECK,
        message: "Browser Storage Details",
        value: storageDetails as unknown as string,
        isCheckPassed: true,
        actionOnFailure: "DeviceValidationFailure"
      }
          resolve(VersionCheck);
    })
  }
  const performCheckRunningProcesses = async (value:[] |string) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
      const checkPassed = value === NOT_AVAILABLE || value.length === 0 ? true : false
      const RunningProcessesCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkRunningProcesses.name || "checkRunningProcesses",
          threshold: DeviceValidation?.checkRunningProcesses.threshold,
          time: TimeService.current(),
          type: DeviceValidation?.checkRunningProcesses?.type || ValidationResponseCheck.SOFT_CHECK,
          message: value === NOT_AVAILABLE ? "Skipped" : checkPassed ? "Success" : "Failure",
          value: value,
          isCheckPassed: checkPassed,
          actionOnFailure: "ProccessCheckError"
        }
          resolve(RunningProcessesCheck);
    })
  }
  const performContentFilteringCheck = async (inputParams:NdtInput) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
      const parentElementId = document.getElementById(inputParams.hostingClientDetails.parentElementId)
      
    const contentFilteringCheck: ValidationResponse & checkStatus = {
      name: DeviceValidation?.checkContentFiltering.name || "checkContentFiltering",
      threshold: DeviceValidation?.checkContentFiltering.threshold,
      time: TimeService.current(),
      type: DeviceValidation?.checkContentFiltering?.type || ValidationResponseCheck.SOFT_CHECK,
      message: "Success",
      value: "NotAvailable",
      isCheckPassed: true,
      actionOnFailure: "ApplicationError"
    }
    if(!parentElementId)resolve(contentFilteringCheck)
    function ExecutionSuccess(e: any) {
      contentFilteringCheck.value = e.detail?.ndtResults?.details?.contentFiltering ?  e.detail?.ndtResults?.details?.contentFiltering : "NotAvailable" 
      console.log(`NDTExecutionCompleted `, e.detail);
      parentElementId?.removeEventListener("NDTExecutionCompleted", ExecutionSuccess);
      parentElementId?.removeEventListener("NDTExecutionError", ExecutionError);
      console.log("[test] the results of content filtering are: ",contentFilteringCheck)
      resolve(contentFilteringCheck)
    }

    function ExecutionError(e: any) {
      //returns NDTOutput
      contentFilteringCheck.value = e.detail?.ndtResults?.details?.contentFiltering ?  e.detail?.ndtResults?.details?.contentFiltering : "NotAvailable" 
      console.log("NDTExecutionError", e.detail);
      parentElementId?.removeEventListener("NDTExecutionCompleted", ExecutionSuccess);
      parentElementId?.removeEventListener("NDTExecutionError", ExecutionError);
      console.log("[test] the results of content filtering are: ",contentFilteringCheck)

      resolve(contentFilteringCheck)
      // NdtOutput
    }
    parentElementId?.addEventListener("NDTExecutionCompleted", ExecutionSuccess);
    parentElementId?.addEventListener("NDTExecutionError", ExecutionError);
    NdtClient.init(inputParams);

  })
  };
  const performCheckStudentComponents = async (value:[] |string) => {
    return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
      const checkPassed = value === NOT_AVAILABLE || value.length === 0 ? true : false
      const RunningProcessesCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkStudentComponents.name || "checkStudentComponents",
          threshold: DeviceValidation?.checkStudentComponents.threshold,
          time: TimeService.current(),
          type: DeviceValidation?.checkStudentComponents?.type || ValidationResponseCheck.SOFT_CHECK,
          message: value === NOT_AVAILABLE ? "Skipped" : checkPassed ? "Success" : "Failure",
          value: value,
          isCheckPassed: checkPassed,
          actionOnFailure: "ApplicationError"//TODO see if we nee to use a different screen.
        }
          resolve(RunningProcessesCheck);
    })
  }
  const npnChecks = ()=>{
      const checkNCSServerHealth = async (ncsHealthResponse:NCSHealthResponse | undefined) => {
      return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
       const NCSServerHealthCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkNCSServerHealth.name || "checkNCSServerHealth",
          threshold: DeviceValidation?.checkNCSServerHealth.threshold,
          time: TimeService.current(),
          type: DeviceValidation?.checkNCSServerHealth.type || ValidationResponseCheck.HARD_CHECK,
          message: "",
          value: "",
          isCheckPassed: false,
          actionOnFailure: "NoNCSConnectionDetected"
        }
        try {
          //const response = await fetchService(healthURL);
          if(ncsHealthResponse){
            NCSServerHealthCheck.message = "Success"
            NCSServerHealthCheck.value = ncsHealthResponse as unknown as string;
            NCSServerHealthCheck.isCheckPassed = true;
          }
         
          resolve(NCSServerHealthCheck);
        }
        catch(e){
          NCSServerHealthCheck.message = "Failed"
          NCSServerHealthCheck.value = e as unknown as string;
          NCSServerHealthCheck.isCheckPassed = false
          resolve(NCSServerHealthCheck);
        }
      })
    }
    const checkRouterConnection = async (ncsHealthResponse:NCSHealthResponse | undefined) => {
      return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
       const ConnectionCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkRouterConnection.name || "checkRouterConnection",
          threshold: DeviceValidation?.checkRouterConnection.threshold,
          time: TimeService.current(),
          type: DeviceValidation?.checkRouterConnection.type || ValidationResponseCheck.HARD_CHECK,
          message: NOT_AVAILABLE,
          value: NOT_AVAILABLE,
          isCheckPassed: false,
          actionOnFailure: "NoRouterConnectionDetected"
        }
        if(ncsHealthResponse){
          const value = {
            ...ncsHealthResponse?.connectionInfo
          }
          ConnectionCheck.message = "Connected"
          ConnectionCheck.value = value  as unknown as string
          ConnectionCheck.isCheckPassed = true;
         }
        resolve(ConnectionCheck);
      })
    }
    const checkNCSEnv = async (ncsHealthResponse:NCSHealthResponse | undefined,studentAppEnv: string) => {
      return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
       const EnvCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkNCSEnv.name || "checkNCSEnv",
          threshold: NOT_AVAILABLE,
          time: TimeService.current(),
          type: DeviceValidation?.checkNCSEnv.type || ValidationResponseCheck.HARD_CHECK,
          message: NOT_AVAILABLE,
          value: NOT_AVAILABLE,
          isCheckPassed: false,
          actionOnFailure: "SystemError"
        }
        if(ncsHealthResponse){
          const value = {
            serverAppEnv: ncsHealthResponse.environment,
            studentAppEnv: studentAppEnv
          }
          EnvCheck.threshold = ncsHealthResponse.environment
          EnvCheck.message = value.serverAppEnv === value.studentAppEnv ? MATCH : MISMATCH
          EnvCheck.value = value as unknown as string
          EnvCheck.isCheckPassed = value.serverAppEnv === value.studentAppEnv
        }
        resolve(EnvCheck);
      })
    }
    const checkNCSVersions = async (ncsHealthResponse:NCSHealthResponse | undefined,releaseVesion:string, componentVersions?: any) => {
      return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
       const VersionCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkNCSVersions.name || "checkNCSVersions",
          threshold: NOT_AVAILABLE,
          time: TimeService.current(),
          type: DeviceValidation?.checkNCSVersions.type || ValidationResponseCheck.HARD_CHECK,
          message:NOT_AVAILABLE,
          value: NOT_AVAILABLE,
          isCheckPassed: false,
          actionOnFailure: "FailedVersionCheck"
        }
        if(ncsHealthResponse){
          const value = {
            ncsReleaseVersion: ncsHealthResponse.eNAEPVersion,
            expectedStudentAppReleaseVersion: ncsHealthResponse.eNAEPVersionStudentApp,
            actualStudentAppReleaseVersion: releaseVesion,
            ...componentVersions
          }
          VersionCheck.threshold = value.expectedStudentAppReleaseVersion
          VersionCheck.message = ncsHealthResponse.eNAEPVersionStudentApp===releaseVesion ? MATCH : MISMATCH
          VersionCheck.value = value as unknown as string
          VersionCheck.isCheckPassed = ncsHealthResponse.eNAEPVersionStudentApp===releaseVesion;
        }
        
        resolve(VersionCheck);
      })
    }
    const checkNCSSystemClock = async (ncsHealthResponse:NCSHealthResponse | undefined) => {
      return new Promise<ValidationResponse & checkStatus>(async (resolve) => {
       const NCSSystemClockCheck: ValidationResponse & checkStatus = {
          name: DeviceValidation?.checkNCSSystemClock.name || "checkNCSSystemClock",
          threshold: DeviceValidation?.checkNCSSystemClock.threshold,
          time: TimeService.current(),
          type: DeviceValidation?.checkNCSSystemClock.type || ValidationResponseCheck.HARD_CHECK,
          message: NOT_AVAILABLE,
          value: NOT_AVAILABLE,
          isCheckPassed: false,
          actionOnFailure: "FailedSystemTimeCheck"
        }
        if(ncsHealthResponse){
          const serverTime = ncsHealthResponse?.date
          const serverTimeUTC = new Date(serverTime);
          const localTimeUTC = TimeService.getNowUTC();
          console.log("[timeservice]",'server time', serverTimeUTC.getTime(), "local time", localTimeUTC.getTime());
          let offset = serverTimeUTC.getTime() - localTimeUTC.getTime();
          const isValid = TimeService.isValidLocalTime(offset, DeviceValidation?.checkNCSSystemClock.threshold); 
          const value = {
            serverTime: serverTime,
            serverTimeUTC: serverTimeUTC,
            studentDeviceTime: TimeService.current(),
            localTimeUTC: localTimeUTC
          }
          NCSSystemClockCheck.message = isValid ? MATCH : MISMATCH,
          NCSSystemClockCheck.value =  value as unknown as string,
          NCSSystemClockCheck.isCheckPassed = isValid
        }
        resolve(NCSSystemClockCheck);
      })
    }
    return { 
      checkNCSEnv,
      checkNCSVersions,
      checkNCSServerHealth,
      checkRouterConnection,
      checkNCSSystemClock
    }
  }
 
  return {
    performBatteryCheck,
    performBrightnessCheck,
    performCPUCheck,
    performChromeExtensionCheck,
    performDeviceCheck,
    performDuplicateScreenCheck,
    performHardwareCheck,
    performMemoryCheck,
    performOSVersionCheck,
    performScreenCheck,
    performScreenResolutionCheck,
    performStorageCheck,
    performTouchDeviceCheck,
    performProccessorCheck,
    performCheckConnection,
    performCheckCloudServerHealth,
    performCheckVersions,
    performCheckSystemClock,
    performCheckBrowserStorage,
    performCheckRunningProcesses,
    performCheckStudentComponents,
    npnChecks,
    performDeviceIdCheck,
    performContentFilteringCheck,
    performSciptPermissions,
    performCheckAppName
   };
}
